
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.938 8.996a.556.556 0 00.562-.564V4.49h2.04a.463.463 0 00.327-.798L6.305.123a.468.468 0 00-.633 0L2.109 3.691a.463.463 0 00.329.798H4.5v3.943c0 .329.234.564.563.564h1.875zM12 8.808a.57.57 0 00-.563-.563H8.25v.187c0 .728-.61 1.315-1.313 1.315H5.063A1.311 1.311 0 013.75 8.432v-.188H.562A.556.556 0 000 8.809v2.629c0 .328.234.563.563.563h10.874a.556.556 0 00.563-.563v-2.63zm-2.906 2.065a.47.47 0 01-.469.47.47.47 0 010-.94.47.47 0 01.469.47zm1.5 0a.47.47 0 01-.469.47.47.47 0 010-.94.47.47 0 01.469.47z","fill":"currentColor"}})])
          )
        }
      }
    